import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARFISH_HOMEPAGE_TO_SAP_DRAFT_V1 = createFcmDetails('starfish_homepage_to_sap_draft_v1', {
	owner: 'starfish',
	context: 'starfish homepage to start a petition draft',
	description:
		'Controls display of the SAP input UI within the Starfish homepage hero section. Used by the starfish_homepage_to_sap_draft_v1 experiment.',
	import: false,
});
